import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.cleanupJobDescription()
  }

  cleanupJobDescription() {
    // Target the cleaned-content div specifically
    const cleanedContent = this.element.querySelector('.cleaned-content')
    if (!cleanedContent) return
    
    const textContent = cleanedContent.innerHTML
    
    // Remove repetitive and messy patterns
    let cleanedHTML = textContent
      // Remove location repetitions
      .replace(/Brazil\s*-\s*Brazil\s*\/?\?\.?/gi, '')
      .replace(/\bConsultant\s*\/\s*/gi, '')
      .replace(/\s*\/\s*Remote\s*/gi, '')
      .replace(/\s*\/\s*$/gm, '') // Remove trailing slashes
      
      // Clean up extra whitespace and breaks
      .replace(/\n\s*\n\s*\n/g, '\n\n')
      .replace(/<br>\s*<br>\s*<br>/gi, '<br><br>')
      .replace(/(<p>\s*<\/p>\s*){2,}/gi, '')
      .replace(/<p>\s*<\/p>/gi, '')
      
      // Remove empty lines and clean spacing
      .replace(/^\s*$\n/gm, '')
      .replace(/\s{3,}/g, ' ')
      
      // Remove paragraphs that only contain location info
      .replace(/<p[^>]*>\s*(Brazil|Remote|Consultant)\s*[\/-]*\s*<\/p>/gi, '')
    
    // Update content if it changed
    if (cleanedHTML !== textContent) {
      cleanedContent.innerHTML = cleanedHTML
    }
    
    // Remove any remaining problematic elements
    const problematicElements = cleanedContent.querySelectorAll('p, div, span')
    problematicElements.forEach(el => {
      const text = el.textContent.trim()
      if (text.match(/^(Brazil\s*-\s*Brazil|Consultant\s*\/|\s*\/\s*)$/i)) {
        el.remove()
      }
    })
  }
}
